import React from 'react'
import moment from 'moment'
import { Box, Modal } from '@mui/material'
import { WUserInterface } from '../services/types/APIResponseType'

type Props = {
  open: boolean
  userDetails: WUserInterface | null
  onClose: () => void
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // backgroundColor: "black",
  width: '100%',
  // borderColor: "#365f91",
  color: 'white',
  border: '1.2px solid transparent',
  // background:
  //   "linear-gradient(black, black) padding-box, linear-gradient(180deg, #365f91 -4.29%, rgba(54, 95, 145, 0) 100%) border-box",
  // borderImageSlice: 1,
  borderRadius: '40px',
}

const WebContactFormDetailsModel: React.FC<Props> = ({
  open,
  userDetails,
  onClose,
}) => {
  return (
    <React.Fragment>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            ...style,
            width: { xs: 'calc(100% - 24px)', sm: '90%', md: 830 },
            maxWidth: 830,
          }}
          className="bg-grad before:rounded-[40px] padding-none overflow-hidden"
        >
          <div className="px-5 py-6 md:px-[80px] md:py-[52px] rounded-[40px] bg-[#2B24600D] backdrop-blur-xl">
            <div className="relative">
              <img
                onClick={() => onClose()}
                className="cursor-pointer absolute right-0 -top-2 md:-right-14 md:-top-5"
                src="./close_icon.svg"
                alt="close icon"
              />
            </div>
            <div>
              <h3 className="text-xl md:text-2xl mb-6 md:mb-10">
                Contact Form Details
              </h3>
            </div>
            <div>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-10 font-normal">
                <div className="col-span-2 md:border-r md:border-[#333]">
                  <p className="text-sm text-[#7D7D7D]  mb-2">Name</p>
                  <p className="text-base md:text-xl break-all px-2">
                    {[userDetails?.firstName, userDetails?.lastName]
                      .filter(Boolean)
                      .join(' ') || 'N/A'}
                  </p>
                </div>
                <div className="col-span-2">
                  <p className="text-sm text-[#7D7D7D]  mb-2">Email Address</p>
                  <p className="text-base md:text-xl">
                    {userDetails?.email || 'N/A'}
                  </p>
                </div>
                <div className="col-span-2 md:border-r md:border-[#333]">
                  <p className="text-sm text-[#7D7D7D]  mb-2">Phone Number</p>
                  <p className="text-base md:text-xl">
                    {userDetails?.phone || 'N/A'}
                  </p>
                </div>
                <div className="col-span-2">
                  <p className="text-sm text-[#7D7D7D]  mb-2">Date & Time</p>
                  <p className="text-base md:text-xl">
                    {userDetails?.updatedAt
                      ? moment(userDetails?.updatedAt).format(
                          'YYYY/MM/DD | h:mm',
                        )
                      : 'N/A'}
                  </p>
                </div>
                <div className="col-span-4">
                  <p className="text-sm text-[#7D7D7D]  mb-2">Description</p>
                  <p className="text-base md:text-xl break-all w-full md:w-[500px]">
                    {userDetails?.description || 'N/A'}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </React.Fragment>
  )
}

export default WebContactFormDetailsModel
